import { jsx as _jsx } from "react/jsx-runtime";
import { AiInterview } from './ai-interview-widget';
import VoiceProviderManagement from './components/voice-provider-management/voice-provider-management';
import VoiceAdminGate from './components/voice-provider-management/voice-admin-gate';
export const VoiceProvidersWidget = ({ config, theme }) => {
    return (_jsx(AiInterview, { config: config, theme: theme, children: _jsx(VoiceAdminGate, { children: _jsx(VoiceProviderManagement, {}) }) }));
};
